import React from "react";
import Header from "./Header";
import TrdEditor from "../trd/TrdEditor";

export default function LayoutTrdDependence() {
  return (
    <>
      <Header />
      <TrdEditor />
    </>
  );
}
